import React, { Component } from 'react';
import { connect } from 'react-redux';

class addUser extends Component {
	render() {
		return (
			<div className="modal fade px-0" id="addUser" aria-labelledby="addUserLabel" aria-hidden="true">
				<div className="modal-dialog px-2 modal-sm">
					<div className="modal-content">
						<header className="modal-header">
							<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">Add user</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="addUserLabel">ajouter un nouveau utilisateur</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						</header>
						<div className="modal-body scroll-default pt-0">
							<p className="h5 lh-copy mb-gutter o-60">Vous pouvez ajouter un nouvel utilisateur à n'importe quel fichier Facilita. Choisissez le dossier et ajoutez les données du nouveau référent.</p>
							<form className="block" noValidate>
								<hr className="mt-0 mb-4" />
								<div className="form-row">
									<div className="form-group col">
										<label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">Prénom *</label>
										<input required type="text" className="form-control" id="Prenom" />
									</div>
									<div className="form-group col">
										<label className="h6 font-weight-bolder my-auto" htmlFor="Nom">Nom *</label>
										<input required type="text" className="form-control" id="Nom" />
									</div>
								</div>
								<div className="form-row text-left">
									<div className="col-lg form-group">
										<label className="h6 font-weight-bolder" htmlFor="email">E-mail</label>
										<input type="email" className="form-control" id="email" placeholder="utilisateuremail@mail.fr" />
										<div className={"invalid-feedback alert alert-danger"}>
											Champs invalide
										</div>
									</div>
									<div className="col col-lg-auto form-group">
										<label className="h6 font-weight-bolder" htmlFor="role">Role</label>
										<select className="form-control custom-select" id="role" aria-label="Default select example">
											<option selected>Choose the role...</option>
											<option value="Admin">Admin</option>
										</select>
									</div>
								</div>
							</form>
						</div>
						<div className="modal-footer pt-0">
							<button type="button" className="btn btn-faded" data-dismiss="modal">Fermer</button>
							<button type="button" className="btn btn-secondary" data-dismiss="modal">Envoyer une invitation</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => ({
	example: state.example,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(addUser);